import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
type Row = {
  item: string;
  free?: boolean;
};
const rows: Row[] = [{
  item: 'Tomo 1 – Mentalidad, Seguridad y Primeros Pasos'
}, {
  item: 'Tomo 2 – Herramientas Básicas para el Hogar'
}, {
  item: 'Tomo 3 – Conocé Tus Paredes Antes de Perforar'
}, {
  item: 'Tomo 4 – Cómo Usar el Taladro Desde Cero'
}, {
  item: 'Tomo 5 – Colgar Repisas, Cuadros, Espejos y Cortinas'
}, {
  item: 'Tomo 6 – Arreglos Básicos y Proyectos de Mejora'
}, {
  item: 'BONO 1 – Checklist de Herramientas Básicas',
  free: true
}, {
  item: 'BONO 2 – Guía de Tornillos, Tarugos y Brocas',
  free: true
}, {
  item: 'BONO 3 – Plantilla Imprimible para Repisas',
  free: true
}, {
  item: 'BONO 4 – Lista de Errores Comunes',
  free: true
}, {
  item: 'BONO 5 – Mini Guía de Proyectos de Fin de Semana',
  free: true
}];
export function IncludedTable() {
  return <section aria-labelledby="incluido-titulo" className="w-full border-y-2 border-ink bg-sand" data-id="element-96" data-mp="2f81o1uuszkcd">
      <div className="mx-auto max-w-4xl px-5 py-16 sm:px-8 sm:py-24" data-id="element-97" data-mp="3aww2gp6gspxq">
        <Reveal data-id="element-98" data-mp="3av1gr8ndctsl">
          <SectionLabel data-id="element-99" data-mp="2wxcv3ylh9imh">Todo lo que recibís</SectionLabel>
          <h2 id="incluido-titulo" className="mt-4 font-display text-3xl font-bold leading-tight sm:text-[2.6rem]" data-id="element-100" data-mp="2wyxo3js58ti8">
            Todo lo que recibís con Manos a la Casa
          </h2>
          <p className="mt-4 text-lg text-graphite" data-id="element-101" data-mp="3po4z3i8sbbkd">
            Un paquete completo para empezar a transformar tu hogar desde el
            primer día.
          </p>
        </Reveal>

        <Reveal delay={0.08} data-id="element-102" data-mp="3fvpesea0mawb">
          <div className="mt-10 overflow-hidden rounded-3xl border-2 border-ink bg-cream shadow-block" data-id="element-103" data-mp="3fue9ub4u2x3m">
            <table className="w-full border-collapse text-left" data-id="element-104" data-mp="cfif0iuq0xst">
              <caption className="sr-only" data-id="element-105" data-mp="ce78wcdszdyj">
                Detalle de tomos y bonos incluidos en la compra
              </caption>
              <thead data-id="element-106" data-mp="r278o42akgra">
                <tr className="bg-ink text-cream" data-id="element-107" data-mp="r2qq7jo1534s">
                  <th scope="col" className="px-5 py-4 font-display text-sm font-bold uppercase tracking-[0.12em] sm:px-7" data-id="element-108" data-mp="r04m5u0cl5rb">
                    Incluido en tu compra
                  </th>
                  <th scope="col" className="px-5 py-4 text-right font-display text-sm font-bold uppercase tracking-[0.12em] sm:px-7" data-id="element-109" data-mp="c5pznjhkre7w">
                    Estado
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-110" data-mp="3uio3w2legt7v">
                {rows.map(({
                item,
                free
              }) => <tr key={item} className="border-t border-ink/10 align-middle transition-colors hover:bg-sand/50" data-id="element-111" data-mp="3ugl62we09vsl">
                    <th scope="row" className="px-5 py-4 text-[15px] font-medium leading-snug text-graphite sm:px-7" data-id="element-112" data-mp="3kk8a1ruzn5uo">
                      {item}
                    </th>
                    <td className="whitespace-nowrap px-5 py-4 text-right sm:px-7" data-id="element-113" data-mp="202peamsxs786">
                      {free ? <span className="inline-flex items-center gap-1.5 rounded-full bg-clay px-3 py-1 text-xs font-bold text-cream" data-id="element-114" data-mp="251ajl0n1ph3h">
                          <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-115" data-mp="2a0dc5llu9uuk" />
                          Gratis
                        </span> : <span className="inline-flex items-center gap-1.5 rounded-full bg-moss/12 px-3 py-1 text-xs font-bold text-moss" data-id="element-116" data-mp="1hbg225rs74cw">
                          <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-117" data-mp="1m9zpkam0wo7d" />
                          Incluido
                        </span>}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Reveal>
      </div>
    </section>;
}